/* eslint-disable fuxi/uppercase-const */

export const TherapyPlanList: Array<{
  name: string;
  key: Massage.MassageItem;
}> = [
  {
    name: '磁震波',
    key: 'Shockwave',
  },
  {
    name: '内源热能',
    key: 'RadioFrequency',
  },
  {
    name: '艾灸',
    key: 'Moxibustion',
  },
  {
    name: '按摩',
    key: 'Massage',
  },
  {
    name: '筋膜再生宝',
    key: 'HotStone',
  },
];

// 目前的理疗类型排序
export const therapyType: Massage.MassageItem[] = ['Shockwave', 'RadioFrequency', 'Moxibustion', 'Massage', 'HotStone'];
export const therapyBodyPart: Service.BodyPart[] = ['Shoulder', 'Waist', 'Back', 'Abdomen', 'LowerBody', 'All'];

export const CommonSelectorStyle = {
  '--border-radius': '16px',
  '--border': 'none',
  '--padding': '8px 20px',
  '--checked-color': '#05f',
  '--checked-text-color': '#fff',
  '--checked-border': 'none',
  '--color': 'rgba(255, 255, 255, 0.50)',
  '--text-color': 'rgba(0, 0, 0, 0.85)',
  '--gap': '12px',
};
